"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    maxH: 280,
    maxW: 452,
    borderRadius: 'md',
};
const SkuImageStyle = {
    baseStyle,
};
exports.default = SkuImageStyle;
